import { gql } from '@/__generated__';

export const GATE_MOVEMENT_FRAGMENT = gql(`#graphql
  fragment GateMovementFragment on GateMovement {
    id
    operationProgress
    positions
    requestedBy {
      id
      name
    }
    requestedPosition
    startPosition
    finishPosition
    lastPosition
    requestedTimestamp
    startTimestamp
    finishTimestamp
    lastPositionTimestamp
    state
    messages {
      id
      gateId
      movementId
      type
      state
      payload
      timestamp
    }
  }
`);
